module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"comment":"Add a reaction"},"fr":{"comment":"Ajouter une réaction"}}')
  delete Component.options._Ctor
}
